import React, { useLayoutEffect, useRef, useState } from "react";
import RadarChart from "../Radar/RadarChart";

type Size = { width: number; height: number };

export default function PlotAutoFit({
  children,
  style,
  className,
}: {
  children: (size: Size) => React.ReactNode;
  style?: React.CSSProperties;
  className?: string;
}) {
  const ref = useRef<HTMLDivElement | null>(null);
  const [size, setSize] = useState<Size>({ width: 0, height: 0 });

  useLayoutEffect(() => {
    const el = ref.current;
    if (!el) return;

    let raf = 0;

    const update = () => {
      const rect = el.getBoundingClientRect();
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(() => {
        setSize({
          width: Math.max(0, Math.floor(rect.width)),
          height: Math.max(0, Math.floor(rect.height)),
        });
      });
    };

    update();
    const ro = new ResizeObserver(update);
    ro.observe(el);

    return () => {
      cancelAnimationFrame(raf);
      ro.disconnect();
    };
  }, []);

  return (
    <div
      ref={ref}
      className={className}
      style={{
        width: "100%",
        height: "100%",
        minHeight: 0,
        position: "relative",
        ...style,
      }}
    >
      {size.width > 10 && size.height > 10 ? children(size) : null}
    </div>
  );
}